import { useHandleClickOutside } from "oolib";
import React, { useRef } from "react";
import { CONTAINER_MAX_HEIGHT } from "../SM_AnnoLightbox/constants";
import { useScrollLightboxIntoView } from "../utils/useScrollLightboxIntoView";

const BOTTOM_SPACE = 50;

export const AnnoLightboxShell = ({
  position,
  handleClickOutside,
  children
}) => {
  const ContainerRef = useRef();

  useHandleClickOutside(ContainerRef, handleClickOutside);

  const { adjustedLeft, adjustedTop } = useScrollLightboxIntoView(
    position,
    ContainerRef,
    {
      assumedHeight: CONTAINER_MAX_HEIGHT * 10,
      bottomSpace: BOTTOM_SPACE
    }
  );

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
        }}
        onClick={handleClickOutside}
      />
      <div
        ref={ContainerRef}
        style={{
          position: "absolute",
          zIndex: 1000,
          left: `${adjustedLeft}px`,
          top: `${adjustedTop}px`,
        }}
      >
        {children}
      </div>
    </>
  );
};